module.exports = __webpack_public_path__ + "static/img/h6-3.8f49662.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd101/h6-3.png
// module id = GxrF
// module chunks = 1